import { useEffect, useState } from 'react';
import { validate, SignUpValidations } from '../../utils/validations';

const enterPhoneNumberErrorMessages = {
    phone: {
        required: 'Please enter your phone number',
        minLength: 'Phone number is too short',
        maxLength: 'Phone number is too long',
        pattern: 'Please enter a valid phone number',
        dangerous: 'Please enter a valid phone number',
    },
};

function useEnterPhoneNumberError (props) {
    const {
        phoneInput,
        touched,
    } = props;

    const [phoneError, setPhoneError] = useState({
        phone: '',
    });

    function validatePhone () {
        if (!touched) {
            return '';
        }

        return validate({
            rules: { ...SignUpValidations.phone },
            messages: enterPhoneNumberErrorMessages.phone,
            value: phoneInput,
        });
    }

    useEffect(() => {
        const err = {
            phone: validatePhone(),
        };
        setPhoneError(err);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [phoneInput, touched]);

    return {
        phoneError,
    };
}

export default useEnterPhoneNumberError;
